/**
 * @Description 创建拓店抽屉 统一处理
 */
import { FC, useEffect, useRef, useState } from 'react';
import CircleTaskCreateDrawer from '../../ExpandStore/CircleTaskCreateDrawer';
import { useSelector } from 'react-redux';
import ExpansionFranchiseeCircleTaskEditDrawer from '@/views/expandstore/pages/expansionFranchiseeCircleTask/pages/edit/Drawer';

const TaskCreateDrawer: FC<any> = ({ showCreateDrawer, setShowCreateDrawer, detail, refresh }) => {
  const [taskTemplateCode, setTaskTemplateCode] = useState<string>('');
  const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);
  const editRef: any = useRef();

  useEffect(() => {
    const { taskTemplateCode } = tenantCheckData;
    taskTemplateCode && setTaskTemplateCode(taskTemplateCode);
  }, [tenantCheckData]);

  useEffect(() => {

    if (showCreateDrawer && taskTemplateCode === 'standardAndClusterA') {
      editRef.current?.init();
    }
  }, [showCreateDrawer, taskTemplateCode]);


  const onClose = () => {
    setShowCreateDrawer(false);
  };

  return (
    <>
      {/* 加盟 疯子说没有这种场景 2024年7月9日 */}
      {/* {taskTemplateCode === 'standardA' && <ExpansionFranchiseeTask location={location} />} */}
      {taskTemplateCode === 'standardA' && <CircleTaskCreateDrawer
        showDrawer={showCreateDrawer}
        setShowDrawer={setShowCreateDrawer}
        businessInfo={detail}
        refresh={refresh}
        isBusiness
      />}
      {/* 直营 */}
      {['clusterA', 'clusterB'].includes(taskTemplateCode) && <CircleTaskCreateDrawer
        showDrawer={showCreateDrawer}
        setShowDrawer={setShowCreateDrawer}
        businessInfo={detail}
        refresh={refresh}
        isBusiness
      />}
      {/* 加盟+直营模板A */}
      {taskTemplateCode === 'standardAndClusterA' && <ExpansionFranchiseeCircleTaskEditDrawer
        businessInfo={detail}
        isBusiness
        ref={editRef}
        reload={refresh}
        onClose={onClose}/>}
    </>
  );
};

export default TaskCreateDrawer;
